
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"131","height":"132","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M83.224 106.545V86.022h24.254v-36.38H128v56.903H83.224zM25.388 84.157H45.91v24.253h36.38v20.523H25.389V84.157zM47.776 25.388V45.91H23.522v36.381H3V25.388h44.776zM105.612 47.776H85.09V23.522H48.708V3h56.903v44.776z","stroke":"#4B62C1","stroke-width":"6","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    